import { NgClass } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  input,
  Output,
} from '@angular/core';
import { ButtonModule } from '@fino-ui/button';
import { FinoIconModule } from '@fino-ui/icon';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-action-box',
  templateUrl: './action-box.component.html',
  styleUrl: './action-box.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FinoIconModule, NgClass, HeaderComponent, ButtonModule],
})
export class ActionBoxComponent {
  header = input<string>();
  subHeader = input<string>();
  icon = input<string>();
  iconSrc = input<string>();
  iconClass = input<string>();
  iconStyles = input<any>({});
  ctaLabel = input<string>('components.action-box.cta');
  active = input<boolean>(null);

  hideCtaButton = input(false, { transform: booleanAttribute });
  isNotClickable = input(false, { transform: booleanAttribute });
  isFullheight = input(true, { transform: booleanAttribute });
  isLoading = input(false, { transform: booleanAttribute });

  @Output() action = new EventEmitter();

  ctaClicked() {
    this.action.next(true);
  }

  hasActiveIndicator = computed(() => this.active() !== null);
}
